import AnimatedCounter from "@/components/AnimatedCounter";

const stats = [
  { value: 480, suffix: "+", label: "Projets accompagnés" },
  { value: 142, prefix: "", suffix: " M€", label: "Primes CEE versées" },
  { value: 1250, prefix: "", suffix: " GWh cumac", label: "Énergie économisée" },
  { value: 65000, prefix: "", suffix: " t CO₂", label: "Émissions évitées" },
  { value: 1200, suffix: "+", label: "Sites audités" },
  { value: 98, suffix: " %", label: "Dossiers validés PNCEE" },
];

export default function StatsBand({ dark = true }) {
  return (
    <section data-testid="stats-band" className={dark ? "relative bg-[#0A0F1A] text-white overflow-hidden" : "bg-white"}>
      {dark && (
        <>
          <div className="absolute inset-0 bg-grid-soft opacity-[0.05] pointer-events-none" />
          <div className="absolute -top-40 right-1/3 h-[420px] w-[420px] rounded-full bg-[#10B981]/15 blur-3xl" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-3xl mb-16">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Chiffres clés</div>
          <h2 className={`font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance leading-[1.05] ${dark ? "text-white" : "text-[#0F172A]"}`}>
            Une nouvelle génération d&apos;experts CEE, déjà à l&apos;échelle nationale.
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/5 rounded-2xl overflow-hidden">
          {stats.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className={`p-7 ${dark ? "bg-[#0A0F1A]" : "bg-white"}`}>
              <div className={`font-display text-3xl md:text-4xl font-bold mb-2 ${dark ? "text-white" : "text-[#0F172A]"}`}>
                <AnimatedCounter value={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} />
              </div>
              <div className={`text-xs md:text-sm leading-relaxed ${dark ? "text-white/55" : "text-[#64748B]"}`}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
